// client/src/context/AuthContext.js
import React, { createContext, useState, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "../apiConfig";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  // Updated state to include a role field
  const [authState, setAuthState] = useState({
    isAuthenticated: null,
    role: null,
  });

  // client/src/context/AuthContext.js
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const { data } = await axios.get(`${API_BASE_URL}/admin/checkAuth`, {
          withCredentials: true,
        });
        setAuthState({ isAuthenticated: data.authenticated, role: data.role });
      } catch (error) {
        setAuthState({ isAuthenticated: false, role: null });
      }
    };
    checkAuth(); // Initial check
    const interval = setInterval(checkAuth, 24 * 60 * 60 * 1000); // Daily
    return () => clearInterval(interval);
  }, []);

  return (
    <AuthContext.Provider value={{ ...authState, setAuthState }}>
      {children}
    </AuthContext.Provider>
  );
};
